const disclaimerModalWarning = (modal, useStorage) => {
    if (!modal) return;

    const acceptBtn = modal.querySelector('[data-modal-btn-close]');
    const storageKey = 'disclaimerModalAccepted';
    const storageModeKey = 'disclaimerModalMode';

    const useStorageBool = useStorage === 'true' || useStorage === true;

    const storedMode = sessionStorage.getItem(storageModeKey);
    if (storedMode !== String(useStorageBool)) {
        sessionStorage.removeItem(storageKey);
        sessionStorage.setItem(storageModeKey, String(useStorageBool));
    }

    const showModal = () => {
        modal.classList.add('visible');
        document.body.classList.add('disable-scroll');
    };

    const hideModal = () => {
        modal.classList.remove('visible');
        document.body.classList.remove('disable-scroll');
    };

    if (useStorageBool) {
        if (!sessionStorage.getItem(storageKey)) {
            showModal();
        }
    } else {
        showModal();
    }

    acceptBtn?.addEventListener('click', () => {
        hideModal();
        if (useStorageBool) {
            sessionStorage.setItem(storageKey, 'true');
        }
    });

    modal.addEventListener('click', (e) => {
        if (e.target === modal) {
            e.stopPropagation();
        }
    });

    window.addEventListener('pageshow', (event) => {
        if (!useStorageBool && event.persisted) {
            showModal();
        }
    });
};

export default disclaimerModalWarning;
